var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "grid-view" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showMainList,
                expression: "showMainList"
              }
            ],
            staticClass: "main-content",
            attrs: { type: "primary" }
          },
          [
            _c(
              "fcl-search-bar",
              {
                attrs: {
                  "is-manage-module": true,
                  filter: _vm.filter,
                  "show-expiration-date": true
                },
                on: {
                  onLevelChanged: _vm.onLevelChanged,
                  simSearchItemCallBack: _vm.toAdvancedQuery,
                  advSearchItemResetCallBack: _vm.toAdvancedQuery,
                  onGridRefresh: _vm.gridRefresh
                }
              },
              [
                _c(
                  "template",
                  { slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { no: "exportToExcel", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.exportToExcel()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Pricing.Export")))]
                    )
                  ],
                  1
                )
              ],
              2
            ),
            _c("fcl-data-grid", {
              attrs: {
                "config-module": "221500",
                "grid-options": _vm.gridOptions,
                "show-approve": true,
                "show-history": true,
                filter: _vm.filter,
                "row-data": _vm.rowData
              }
            })
          ],
          1
        ),
        _c("price-dialog", {
          attrs: {
            visible: _vm.priceDialog.visible,
            price: _vm.priceDialog.price,
            "price-addon": _vm.priceDialog.priceAddon,
            "is-dangerous": _vm.priceDialog.isDangerous,
            "un-no": _vm.priceDialog.unNo,
            "etd-date": _vm.priceDialog.etdDate,
            level: _vm.priceDialog.level
          },
          on: { close: _vm.onPriceDialogClose }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }